import constants from '../constants';
import trackEvent from './track-event';

const { events } = constants;

const trackReadOnlyControlTaken = () => trackEvent(events.READONLY_CONTROL_TAKEN);

export default trackReadOnlyControlTaken;
